import React from "react";
import { FileSpreadsheet, CheckCircle, AlertTriangle, XCircle } from "lucide-react";

const ColumnAnalysisTable = ({ details }) => {
  if (!details || details.length === 0) return null;

  const getQualityColor = (score) => {
    const numScore = typeof score === "string" ? parseFloat(score.replace("%", "")) : parseFloat(score);
    if (numScore >= 90) return "#10b981";
    if (numScore >= 70) return "#f59e0b";
    return "#ef4444";
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg border-2 border-gray-100 overflow-hidden">
      <div className="p-6 border-b-2 border-gray-100 bg-gradient-to-r from-gray-50 to-gray-100">
        <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
          <FileSpreadsheet className="w-5 h-5 text-blue-600" />
          Column-Level Analysis
        </h3>
      </div>
      <div className="overflow-x-auto">
        <div className="max-h-[600px] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="bg-gradient-to-r from-blue-50 to-indigo-50 sticky top-0 z-10">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-black text-gray-700 uppercase tracking-wider border-b-2 border-blue-200">
                  Column
                </th>
                <th className="px-6 py-4 text-left text-xs font-black text-gray-700 uppercase tracking-wider border-b-2 border-blue-200">
                  Dimension
                </th>
                <th className="px-6 py-4 text-left text-xs font-black text-gray-700 uppercase tracking-wider border-b-2 border-blue-200">
                  Rule
                </th>
                <th className="px-6 py-4 text-center text-xs font-black text-gray-700 uppercase tracking-wider border-b-2 border-blue-200">
                  Score
                </th>
                <th className="px-6 py-4 text-center text-xs font-black text-gray-700 uppercase tracking-wider border-b-2 border-blue-200">
                  Total
                </th>
                <th className="px-6 py-4 text-center text-xs font-black text-gray-700 uppercase tracking-wider border-b-2 border-blue-200">
                  Success
                </th>
                <th className="px-6 py-4 text-center text-xs font-black text-gray-700 uppercase tracking-wider border-b-2 border-blue-200">
                  Failed
                </th>
                <th className="px-6 py-4 text-center text-xs font-black text-gray-700 uppercase tracking-wider border-b-2 border-blue-200">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {details.map((row, idx) => {
                const score = parseFloat(row.success_rate || row.score || 0);
                return (
                  <tr key={idx} className="hover:bg-blue-50 transition-colors duration-200">
                    <td className="px-6 py-4 text-xs font-bold text-gray-900">
                      {row.column || row.column_name}
                    </td>
                    <td className="px-6 py-4 text-xs text-gray-600 font-medium">
                      {row.dimension || row.data_type || "N/A"}
                    </td>
                    <td className="px-6 py-4 text-xs text-gray-600">{row.rule || "N/A"}</td>
                    <td className="px-6 py-4 text-center">
                      <span
                        className="inline-block px-3 py-1 rounded-full text-xs font-black"
                        style={{
                          backgroundColor: `${getQualityColor(score)}20`,
                          color: getQualityColor(score),
                        }}
                      >
                        {score.toFixed(1)}%
                      </span>
                    </td>
                    <td className="px-6 py-4 text-xs text-gray-700 text-center font-semibold">
                      {(row.total_records || row.total || 0).toLocaleString()}
                    </td>
                    <td className="px-6 py-4 text-xs text-green-600 text-center font-semibold">
                      {(row.success_count || row.success || 0).toLocaleString()}
                    </td>
                    <td className="px-6 py-4 text-xs text-red-600 text-center font-semibold">
                      {(row.fail_count || row.fail || 0).toLocaleString()}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {score >= 90 ? (
                        <CheckCircle className="w-5 h-5 text-green-500 mx-auto" />
                      ) : score >= 70 ? (
                        <AlertTriangle className="w-5 h-5 text-yellow-500 mx-auto" />
                      ) : (
                        <XCircle className="w-5 h-5 text-red-500 mx-auto" />
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ColumnAnalysisTable;